import { Injectable, OnDestroy } from '@angular/core';
import { NumberTypes, TranslocoLocaleService, ValidDate } from '@ngneat/transloco-locale';

/**
 * Service used to wrap the transloco locale service and add some additional functionality
 */

@Injectable({
    providedIn: 'root',
})
export class TranslocoLocaleWrapperService implements OnDestroy {
    private groupSeparator: string;
    private decimalSeparator: string;

    constructor(private translocoLocaleService: TranslocoLocaleService) {
        this.setLocaleSeparators(this.translocoLocaleService.getLocale());
    }

    ngOnDestroy(): void {
        this.translocoLocaleService.ngOnDestroy();
    }

    getLocale = () => {
        return this.translocoLocaleService.getLocale();
    };

    setLocale = (locale: string) => {
        this.setLocaleSeparators(locale);
        this.translocoLocaleService.setLocale(locale);
    };

    getNumberGroupSeparator = () => this.groupSeparator;

    getNumberDecimalSeparator = () => this.decimalSeparator;

    setLocaleSeparators = (locale: string) => {
        var locale = this.getLocale();
        // A weird hack for icelandic, javascripts Intl doesn't seem to handle it correctly and assumes iceland uses a comma for group separation and a dot for decimal separation.
        if (locale == 'is-IS') {
            locale = 'de-DE';
        }
        const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
        this.groupSeparator = parts.find((x) => x.type == 'group').value;
        this.decimalSeparator = parts.find((x) => x.type == 'decimal').value;
    };

    localizeNumber = (value: string | number, type: NumberTypes = 'decimal', options?: Intl.NumberFormatOptions) => {
        if (options) {
            return this.translocoLocaleService.localizeNumber(value, type, this.getLocale(), options);
        }
        return this.translocoLocaleService.localizeNumber(value, type);
    };

    parseLocalizedNumber = (value: string) => {
        if (value == null) {
            return 0;
        }

        let numberString = value;
        // Remove the group separators if present
        if (this.groupSeparator) {
            // Escape the separator in the regex in case it is a dot
            numberString = numberString.replace(new RegExp(this.groupSeparator.replace(/[.]/g, '\\$&'), 'g'), '');
        }

        // Replace the decimal separator with a dot in case the current locale has it as a comma
        if (this.decimalSeparator && this.decimalSeparator != '.') {
            numberString = numberString.replace(this.decimalSeparator, '.');
        }

        let result = parseFloat(numberString);

        return isNaN(result) ? 0 : result;
    };

    localizeDate = (date: ValidDate) => {
        return this.translocoLocaleService.localizeDate(date);
    };
}
